(() => {
  const intro = document.querySelector('.bp-bow-intro');
  if (!intro) return;
  const info = intro.closest('product-info');
  const colors = {
    Fucsia: 'https://cdn.shopify.com/s/files/1/0938/3657/5002/files/lacitos-mini-fucsia-alfombra-crema.png?v=1792794473',
    Rosita: 'https://cdn.shopify.com/s/files/1/0938/3657/5002/files/lacitos-mini-rosita-alfombra-crema.png?v=1792794463',
    Rojo: 'https://cdn.shopify.com/s/files/1/0938/3657/5002/files/lacitos-mini-rojo-alfombra-crema.png?v=1792797294'
  };
  const isSpanish = document.documentElement.lang.startsWith('es');
  const englishColors = {Fucsia:'Fuchsia', Rosita:'Light pink', Rojo:'Red'};
  const colorKey = value => ({Fuchsia:'Fucsia', 'Light pink':'Rosita', Red:'Rojo'}[value] || value);
  const labels = new Map([
    ['Escoge tus lacitos / Choose your bows', 'Choose your bows'],
    ['2 lacitos','2 bows'], ['4 lacitos','4 bows'], ['6 lacitos','6 bows'],
    ['🎃 Bandana gratis hasta el 31 de octubre · 1 por orden', '🎃 Free bandana through October 31 · 1 per order'],
    ['Bandana de Halloween GRATIS','FREE Halloween bandana'],
    ['Rosita','Light pink']
  ]);
  let queued = false;
  function paint() {
    queued = false;
    const root = info.querySelector('#mb_no_atc_cxbundle-funnel');
    if (!root) return;
    if (!isSpanish) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) {
        if (textNode.parentElement.closest('script,style')) continue;
        const original = textNode.nodeValue.trim();
        if (labels.has(original)) textNode.nodeValue = textNode.nodeValue.replace(original, labels.get(original));
      }
    }
    const giftData = document.getElementById('bp-bow-gift-variants');
    let giftVariants = [];
    try { giftVariants = JSON.parse(giftData?.textContent || '[]'); } catch (_) {}
    root.querySelectorAll('.mb_gifts_section select').forEach((select) => {
      const optionIndex = ['Diseño','Design'].includes(select.name) ? 0 : ['Talla','Size'].includes(select.name) ? 1 : -1;
      if (optionIndex < 0) return;
      Array.from(select.options).forEach((option) => {
        if (giftVariants.some(variant => variant.available && variant.options[optionIndex] === option.value)) {
          const clean = option.textContent.replace(/\s*[-–]?\s*(?:¡Este artículo está agotado!|This item is out of stock!)\s*/g,'').trim();
          if (clean !== option.textContent) option.textContent = clean;
        }
      });
    });
    root.querySelectorAll('.varaints-sec').forEach((row) => {
      const select = row.querySelector('select[name="Color"]');
      if (!select || !colors[colorKey(select.value)]) return;
      const options = Array.from(select.options);
      if (options.map(o=>colorKey(o.value)).join('|') !== 'Fucsia|Rosita|Rojo') {
        const selected = select.value;
        Object.keys(colors).forEach(color => { const option = options.find(o=>colorKey(o.value)===color); if(option) select.append(option); });
        select.value = selected;
      }
      row.classList.add('bp-bow-color-row');
      let figure = row.querySelector('.bp-bow-selection-photo');
      if (!figure) {
        figure = document.createElement('figure');
        figure.className = 'bp-bow-selection-photo';
        const crop = document.createElement('span');
        crop.className = 'bp-bow-single-crop';
        const img = document.createElement('img');
        img.width = 144; img.height = 108; img.loading = 'lazy';
        crop.append(img);
        figure.append(crop,document.createElement('figcaption'));
        row.prepend(figure);
      }
      const color = colorKey(select.value);
      const displayColor = isSpanish ? color : englishColors[color];
      const img = figure.querySelector('img');
      if (img.getAttribute('src') !== colors[color]) img.src = colors[color];
      img.alt = (isSpanish ? 'Un lacito ' : 'One bow: ') + displayColor.toLowerCase();
      const offsets = {Fucsia: ['-43.33%', '-32%', '482.67%'], Rosita: ['-282.69%', '-115.38%', '556.92%'], Rojo: ['-19.35%', '-65.81%', '467.10%']};
      const crop = figure.querySelector('.bp-bow-single-crop');
      crop.style.setProperty('--bow-left',offsets[color][0]);
      crop.style.setProperty('--bow-top',offsets[color][1]);
      crop.style.setProperty('--bow-width',offsets[color][2]);
      if (figure.lastElementChild.textContent !== displayColor) figure.lastElementChild.textContent = displayColor;
      const label = row.querySelector('.variant-option-name');
      const number = Array.from(row.parentElement.querySelectorAll('.varaints-sec')).indexOf(row) + 1;
      const bowLabel = (isSpanish ? 'Lacito ' : 'Bow ') + number;
      if (label && label.textContent !== bowLabel) label.textContent = bowLabel;
      select.setAttribute('aria-label',(isSpanish ? 'Color del lacito ' : 'Bow color ') + number);
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
  new MutationObserver(schedule).observe(info,{childList:true,subtree:true});
  info.addEventListener('change',schedule);
  paint();
})();
